import React, { Component } from "react";
import "../../css/route.css";
import {Modal, Table, Glyphicon } from 'react-bootstrap';
import Collapsible from '../../components/Collapsible';
import moment from "moment";
import { getTimeInIST, format_fancy, format_display_DDMMYYYY } from "../../Utils";
import {ProductService} from '../../Services/ProductService';
import { ReportService } from "../../Services/ReportService";

export default class PendingBottle extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        products: [],
        productRows: [],
        message : "",
        total: 0,
        show: false,
        detailed: [],
        detailedRow: []
      }
      this.viewTransactions = this.viewTransactions.bind(this);
      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            detailed: [],
            detailedRow: []
        });
    }

    handleShow() {
        this.setState({ show: true });
    }
 
    componentDidMount(){
        this.props.isLoading(true);
        ProductService.getProductList()
        .then((data) => {
            console.log(data);
            let products = data.products.filter((product) => {
                return product.status !== -1 && product.bottled === "1";
            });
            this.setState({products: products});
            this.fetchData();
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    viewTransactions(e, report){
        e.preventDefault();
        let detailedRow = [];
        ReportService.getReportPendingBottleDetails(report.customer_id, report.product_id)
        .then((data) => {
            console.log(data.report);
            data.report.forEach((report) => {
                detailedRow.push(
                    <TransactionDetails key={report.id} report={report}/>
                );
            });
            this.setState({
                detailed: data.report,
                detailedRow
            });
            this.handleShow();
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchData(){
        this.props.isLoading(true);
        let productRows = [];
        let productMap = new Map();
        ReportService.getReportPendingBottles()
        .then((data) => {
            console.log(data.report);
            this.setState({
                data: data.report
            });
            let total = 0;
            data.report.forEach((report) => {
                let a = [];
                if(productMap.has(report.product_name)){
                    a = productMap.get(report.product_name);
                }
                a.push(<ReportDetails key={report.id} report={report} viewTransactions={this.viewTransactions}/>);
                productMap.set(report.product_name, a);
            });
            productMap.forEach((value, key, map) => {
                let t  = value.reduce((sum, value) => sum + parseInt(value.props.report.bottles_pending, 10), 0);
                total += t
                productRows.push(
                    <PendingBottleSection key={key} title={key} rows={value} total={t}/>
                );
            });
            this.setState({total, productRows: productRows, productMap: productMap, message: this.state.products.length > 0 ? "" : "No Data available"});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }
    
    render() {
        const message = this.state.message;
        return (
            <div className="Home">
                <h3 style={{marginBottom: '20px'}}>Pending Bottle Report (Total : {this.state.total})</h3>
                { !this.props.loading &&
                    <div className="container">
                        {this.state.productRows}
                    </div>
                }
                {
                    message && 
                    (
                        <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    )
                }
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.show ? "Transactions" : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Table striped condensed hover responsive>
                            <thead>
                                <tr>
                                    <th>Scheduled Date</th>
                                    <th>Actual Delivery</th>
                                    <th>Delivered Count</th>
                                    <th>Bottles Returned</th>
                                </tr>
                            </thead>
                            <tbody style={{textAlign: "left"}}>
                                {this.state.detailedRow}
                            </tbody>
                        </Table>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

}

class PendingBottleSection extends Component {

    render() {

        return (
            <Collapsible key={this.props.title} title={this.props.title + "(" + this.props.total + ")"}>
                <Table striped condensed hover responsive>
                    <thead>
                        <tr>
                            <th>Customer Name</th>
                            <th>Customer Mobile No</th>
                            <th>Route</th>
                            <th>Bottles Pending</th>
                            <th>View Transactions</th>
                        </tr>
                    </thead>
                    <tbody style={{textAlign: "left"}}>
                        {this.props.rows}
                    </tbody>
                </Table>
            </Collapsible>
        );
    }
}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        return (
            <tr>
                <td>{report.customer_name}</td>
                <td>{report.customer_mobile_no}</td>
                <td>{report.route_id}</td>
                <td>{report.bottles_pending}</td>
                <td>
                    <Glyphicon style={{marginRight: "10px"}} glyph="book" onClick={(e) => this.props.viewTransactions(e, report)} />
                </td>
            </tr>
        );
    }
}

class TransactionDetails extends Component {

    render(){
        const report = this.props.report;
        return (
            <tr>
                <td>{moment(report.schedule_date).format(format_display_DDMMYYYY)}</td>
                <td>{getTimeInIST(report.delivery_date).format(format_fancy)}</td>
                <td>{report.delivered_count}</td>
                <td>{report.bottles_returned}</td>
            </tr>
        );
    }
}